module.exports = __webpack_public_path__ + "static/media/pallet.0d0642df.svg";